import React from 'react'

const EditPnp = () => {
  return (
    <div>EditPnp</div>
  )
}

export default EditPnp